import React from 'react';

import './FeaturedEvent.scss';

// const ROOT_CLASSNAME = 'FeaturedEvent';

export const FeaturedEvent: React.FunctionComponent<any> = ({ theme }) => {
  return null;
};
